import {
  AlphabetCollectionsDraftApi,
  useAPIQueryAndQueryKey,
} from "melco-shared-logic";
import { PublishState } from "../../../helper/publishedState";

export const queryKeyForFontCollection = (
  fontCollectionId: string,
  publishState: PublishState
) => ["fontCollection", fontCollectionId, publishState];

export const useFontCollection = (
  fontCollectionId: string,
  publishState: PublishState
) => {
  return useAPIQueryAndQueryKey(
    AlphabetCollectionsDraftApi,
    queryKeyForFontCollection(fontCollectionId, publishState),
    async (api) =>
      api.userAlphabetCollectionsGetDef({ id: fontCollectionId, publishState })
  );
};
